/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * EventIcon
 */
export default class EventIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M15.883 1.007L16 1a1 1 0 01.993.883L17 2v1h2a3 3 0 013 3v2.966l.005.084c0 .029 0 .056-.003.084L22 20a3 3 0 01-3 3H5a3 3 0 01-3-3V6a3 3 0 013-3h2V2a1 1 0 01.883-.993L8 1a1 1 0 01.993.883L9 2v1h6V2a1 1 0 01.883-.993L16 1zM20 10.05H4V20a1 1 0 001 1h14a1 1 0 001-1v-9.95zm-7.103 2.507l.649 1.315 1.451.211a1 1 0 01.554 1.706l-1.05 1.024.248 1.445a1 1 0 01-1.451 1.054L12 18.63l-1.298.682a1 1 0 01-1.451-1.054l.248-1.445-1.05-1.024a1 1 0 01.554-1.706l1.451-.21.65-1.316a1 1 0 011.793 0zM7 5H5a1 1 0 00-1 1v2.05h16V6a1 1 0 00-1-1h-2v1a1 1 0 01-.883.993L16 7a1 1 0 01-.993-.883L15 6V5H9v1a1 1 0 01-.883.993L8 7a1 1 0 01-.993-.883L7 6V5z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

